exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0;background-image:-webkit-linear-gradient(left,#ddd,#b4b4b4);background-image:-moz-linear-gradient(left,#ddd,#b4b4b4);background-image:-ms-linear-gradient(left,#ddd,#b4b4b4);background-image:-o-linear-gradient(left,#ddd,#b4b4b4);background-image:linear-gradient(90deg,#ddd,#b4b4b4)}#app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center}.component{margin:0 auto}a{text-decoration:none;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c3cb92be","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 157
// module chunks = 0